import React from "react";
import { Company } from "~/Company";

import { DVIRs } from "~/DVIR";
import { FilterRow } from "~/Filter";
import * as Layout from "~/Layout";
import * as Log from "~/Log";
import { Route as GenericRoute } from "~/Route";
import * as Preferences from "~/Preferences";

import { Filter } from "~/Driver";
import { shouldShowSelectAFilterPrompt } from "~/DisabledTable";

export function Missing() {
    const updateFilters = Preferences.Put.use();
    const [ loadingFilters, userPreferences] = Preferences.Get.useLoading()

    const { company } = Company.use();

    const onFilterByBranch = (
      filteredBranchIds: Company.Branch.Branches.BranchIDs
    ) => {
      const filterPreferences = {
        [`${Preferences.preferenceKey("branchFilter")}`]: filteredBranchIds,
      };
      updateFilters.request(
        {
          ...userPreferences,
          ...filterPreferences,
        },
        "Logs Table",
        "branchFilter"
      );
    };
  
    const onFilterWorkReportingLocation = (
      filteredWorkReportingLocationIds: Filter.Filter
    ) => {
      const filterPreferences = {
        [`${Preferences.preferenceKey(
          "locationFilter"
        )}`]: filteredWorkReportingLocationIds,
      };
      updateFilters.request(
        {
          ...userPreferences,
          ...filterPreferences,
        },
        "Logs Table",
        "locationFilter"
      );
    };

    const disableMissingLogs = shouldShowSelectAFilterPrompt({companyId: company.id, userPreferences})

  return (
    <Layout.Page.Component all>
      <FilterRow>
          <Company.Branch.Branches.Filter.Component onFilter={onFilterByBranch} />
          <Company.Location.Filter.Component
            onFilter={onFilterWorkReportingLocation}
          />
        </FilterRow>
        { disableMissingLogs ? 
        (<Log.PromptToAddFiltersForLogs missingDVIRs={true} isLoading={loadingFilters} baseRoute={Missing.Route.definition()} />) 
        : (<Log.Summaries missingDVIRs={true} baseRoute={Missing.Route.definition()} />)
        }
    </Layout.Page.Component>
  );
}

export namespace Missing {
  export namespace Route {
    export const definition = () =>
      `${DVIRs.Route.WithoutInterval.definition()}/missing`;

    export const href = definition;
    export const use = () => GenericRoute.use(href());
  }
}
